import { BillingTierDB } from "../admin/types";

/**
 * Defines Auth State interface
 */
export interface StripePaymentMethod {
  brand: string;
  last4: string;
  expMonth: number;
  expYear: number;
}
export interface GNUserPublic {
  userID: string,
  country: string,
  userName: string,
  userEmail: string,
  userRole: string,
  userPictureUrl: string,
  sinceTimestamp: number, 
  settings: {
    isColaborationEmailSubscribed: boolean,
    stripePaymentMethod?: StripePaymentMethod;
  },
  monthToDateUsageCost?: number
}

export interface GNSystemSettings {
  actualUEPluginVersion: string,
  latestUEPluginVersionDownloadURL: string,
  publicBillingTiers: BillingTierDB[]
}

export interface AuthState {
    // http state
    httpInProgress: boolean;
    httpUpdateInProgress: boolean;
    httpError: string;
    // auth server structure
    authToken: string;
    gnUser: GNUserPublic;
    systemSettings: GNSystemSettings;
  }
  
  /**
   * Defines Auth actions names
   */
  export const AUTH_IN_PROGRESS = 'AUTH_IN_PROGRESS'
  export const AUTH_UPDATE_IN_PROGRESS = 'AUTH_UPDATE_IN_PROGRESS'
  export const AUTH_UPDATE_TOKEN = 'AUTH_UPDATE_TOKEN'
  export const AUTH_ERROR = 'AUTH_ERROR'
  export const AUTH_CLEAR_ERROR = 'AUTH_CLEAR_ERROR'
  export const AUTH_LOGIN = 'AUTH_LOGIN'
  export const AUTH_LOGOUT = 'AUTH_LOGOUT'
  export const AUTH_UPDATE_GNUSER = 'AUTH_UPDATE_GNUSER'
  export const AUTH_UPDATE_BILLING_TIERS = 'AUTH_UPDATE_BILLING_TIERS'
  
  /**
   * Defines Auth actions interfaces
   */
  interface AuthInProgressAction {
    type: typeof AUTH_IN_PROGRESS;
  }
  interface AuthUpdateInProgressAction {
    type: typeof AUTH_UPDATE_IN_PROGRESS;
  }
  interface AuthUpdateTokenAction {
    type: typeof AUTH_UPDATE_TOKEN;
    authToken: string;
  }
  interface AuthErrorAction {
    type: typeof AUTH_ERROR;
    error: string;
  }
  interface AuthLoginAction {
    type: typeof AUTH_LOGIN;
    payload: AuthState;
  }
  interface AuthLogoutAction {
    type: typeof AUTH_LOGOUT;
  }
  interface AuthClearErrorAction {
    type: typeof AUTH_CLEAR_ERROR;
  }
  interface AuthUpdateGNUserAction {
    type: typeof AUTH_UPDATE_GNUSER;
    payload: {
      gnUser: GNUserPublic;
    };
  }
  interface AuthUpdateBillingTiersAction {
    type: typeof AUTH_UPDATE_BILLING_TIERS;
    publicBillingTiers: BillingTierDB[];
  }

  /**
   * Defines all suported actions for Auth
   */
  export type AuthActionTypes =
    AuthLoginAction |
    AuthInProgressAction |
    AuthUpdateInProgressAction |
    AuthUpdateTokenAction |
    AuthLogoutAction |
    AuthErrorAction |
    AuthClearErrorAction |
    AuthUpdateGNUserAction |
    AuthUpdateBillingTiersAction;
  
  /**
   * Defines AuthActionsInterface
   */
  export interface AuthActionsInterface {
    authSetError: (error: string) => void;
    authClearError: () => void;
    authLogout: () => void;
    authLogin: (googleAuthToken: string) => Promise<void>;
    authRenewUserData: () => Promise<any>;
    authDeleteAccount: () => Promise<any | undefined>;
    authUpdateSettings: (settings: Partial<GNUserPublic['settings']>) => Promise<any | undefined>;
    authUpdateToken: (authToken: string) => Promise<void>;
    authUpdateBillingTiersInAuthStorage: (publicBillingTiers: BillingTierDB[]) => void;
    authUserBillingGetStripeClientSecret: () => Promise<any>;
    authUserBillingRemovePaymentMethod: () => Promise<any>;
  }